 

// /* eslint-disable no-constant-binary-expression */
// // ContractsTab.tsx
// import React, { useEffect, useState } from 'react';
// import { Card, CardBody } from '@components/card/card';
// import NeatixModal from '@components/Modal/NeatixModal';
// import Loading from '@components/Shared/Loader/Loading';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { useTranslation } from 'react-i18next';
// import ContractForm from './ContractForm';
// import ViewContract from './ViewContract';
// import { usePermissions } from '@Helper/Permisstions/usePermissions';
// import { getContractsList } from '@store/HR/Person/contractsSlice';

// interface ContractsTabProps {
//   personId: string;
// }

// const ContractsTab: React.FC<ContractsTabProps> = ({ personId }) => {
//   const dispatch = useAppDispatch();
//   const { t } = useTranslation();
//   const { HasPermission } = usePermissions();

//   const [showAddModal, setShowAddModal] = useState<boolean>(false);
//   const [showViewModal, setShowViewModal] = useState<boolean>(false);
//   const [selectedContract, setSelectedContract] = useState<any>(null);

//   const { contractsList, loading, error } = useAppSelector(state => state.PersonContracts);

//   useEffect(() => {
//     if (personId) {
//       dispatch(getContractsList(personId));
//     }
//   }, [dispatch, personId]);

//   // دالة لتحديد العقد الحالي
//   const getCurrentContract = () => {
//     const today = new Date();
//     return contractsList.find(contract => {
//       const endDate = new Date(contract.endDate);
//       return contract.contractStatus === 'active' && endDate >= today;
//     });
//   };

//   // دالة للحصول على العقود السابقة
//   const getPreviousContracts = () => {
//     const today = new Date();
//     return contractsList.filter(contract => {
//       const endDate = new Date(contract.endDate);
//       return contract.contractStatus !== 'active' || endDate < today;
//     });
//   };

//   const currentContract = getCurrentContract();
//   const previousContracts = getPreviousContracts();

//   const handleAddSuccess = () => {
//     setShowAddModal(false);
//     setSelectedContract(null);
//     dispatch(getContractsList(personId));
//   };

//   const handleViewContract = (contract: any) => {
//     setSelectedContract(contract);
//     setShowViewModal(true);
//   };

//   const handleEditContract = (contract: any) => {
//     setSelectedContract(contract);
//     setShowAddModal(true);
//   };

//   const getStatusBadge = (status: string) => {
//     switch (status) {
//       case 'active':
//         return 'bg-success';
//       case 'expired':
//         return 'bg-warning';
//       case 'terminated':
//         return 'bg-danger';
//       case 'suspended':
//         return 'bg-secondary';
//       default:
//         return 'bg-secondary';
//     }
//   };

//   const getStatusText = (status: string) => {
//     switch (status) {
//       case 'active':
//         return 'نشط';
//       case 'expired':
//         return 'منتهي';
//       case 'terminated':
//         return 'ملغي';
//       case 'suspended':
//         return 'موقوف';
//       default:
//         return status;
//     }
//   };

//   const calculateRemainingDays = (endDate: string) => {
//     const today = new Date();
//     const end = new Date(endDate);
//     const diffTime = end.getTime() - today.getTime();
//     const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
//     return diffDays > 0 ? diffDays : 0;
//   };

//   const calculateContractDuration = (startDate: string, endDate: string) => {
//     const start = new Date(startDate);
//     const end = new Date(endDate);
//     const diffTime = end.getTime() - start.getTime();
//     return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
//   };

//   return (
//     <Loading loading={loading} error={error}>
//       <div>
//         {/* قسم العقد الحالي */}
//         {currentContract ? (
//           <Card className='mb-4 border-success'>
//             <div className='card-header bg-success bg-opacity-10 border-success d-flex justify-content-between align-items-center'>
//               <h5 className='mb-0 text-success'>
//                 <i className='fa fa-star me-2'></i>
//                 العقد الحالي
//               </h5>
//               <div>
//                 <span className='badge bg-success me-2'>
//                   <i className='fa fa-clock me-1'></i>
//                   {calculateRemainingDays(currentContract.endDate)} يوم متبقي
//                 </span>
//                 <span className='badge bg-primary'>
//                   {calculateContractDuration(currentContract.startDate, currentContract.endDate)} يوم
//                 </span>
//               </div>
//             </div>
//             <CardBody>
//               <div className='row'>
//                 <div className='col-md-3'>
//                   <div className='text-center mb-3'>
//                     <h4 className='text-theme'>{currentContract.contractNumber}</h4>
//                     <small className='text-muted'>رقم العقد</small>
//                   </div>
//                 </div>
//                 <div className='col-md-3'>
//                   <div className='text-center mb-3'>
//                     <h6 className='text-dark'>{currentContract.contractType}</h6>
//                     <small className='text-muted'>نوع العقد</small>
//                   </div>
//                 </div>
//                 <div className='col-md-3'>
//                   <div className='text-center mb-3'>
//                     <h6 className='text-dark'>{currentContract.startDate?.split('T')[0]}</h6>
//                     <small className='text-muted'>تاريخ البداية</small>
//                   </div>
//                 </div>
//                 <div className='col-md-3'>
//                   <div className='text-center mb-3'>
//                     <h6 className='text-dark'>{currentContract.endDate?.split('T')[0]}</h6>
//                     <small className='text-muted'>تاريخ النهاية</small>
//                   </div>
//                 </div>
//               </div>

//               <div className='row mt-3'>
//                 <div className='col-md-6'>
//                   <div className='d-flex flex-wrap gap-2'>
//                     <span className='badge bg-info'>{currentContract.annualLeave} يوم إجازة سنوية</span>
//                     <span className={`badge ${currentContract.approvedFlag ? 'bg-success' : 'bg-warning'}`}>
//                       {currentContract.approvedFlag ? 'معتمد' : 'غير معتمد'}
//                     </span>
//                     <span className='badge bg-secondary'>{currentContract.signedBy}</span>
//                   </div>
//                 </div>
//                 <div className='col-md-6 text-end'>
//                   <div className='btn-group'>
//                     <button
//                       onClick={() => handleViewContract(currentContract)}
//                       className='btn btn-outline-theme btn-sm'
//                     >
//                       <i className='fa fa-eye me-1'></i>
//                       عرض التفاصيل
//                     </button>
//                     {true && (
//                       <button onClick={() => handleEditContract(currentContract)} className='btn btn-theme btn-sm'>
//                         <i className='fa fa-edit me-1'></i>
//                         تعديل
//                       </button>
//                     )}
//                   </div>
//                 </div>
//               </div>

//               {currentContract.description && (
//                 <div className='row mt-3'>
//                   <div className='col-12'>
//                     <div className='border-top pt-3'>
//                       <h6 className='text-muted'>ملاحظات:</h6>
//                       <p className='mb-0'>{currentContract.description}</p>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </CardBody>
//           </Card>
//         ) : (
//           <Card className='mb-4 border-warning'>
//             <CardBody className='text-center py-4'>
//               <i className='fa fa-exclamation-triangle fa-2x text-warning mb-3'></i>
//               <h5 className='text-warning'>لا يوجد عقد نشط حالياً</h5>
//               <p className='text-muted mb-3'>هذا الموظف لا يمتلك عقداً نشطاً في الوقت الحالي</p>
//               {true && (
//                 <button className='btn btn-theme' onClick={() => setShowAddModal(true)}>
//                   <i className='fa fa-plus me-2'></i>
//                   إضافة عقد جديد
//                 </button>
//               )}
//             </CardBody>
//           </Card>
//         )}

//         {/* قسم العقود السابقة - كجدول */}
//         <Card className='mb-4'>
//           <div className='card-header d-flex justify-content-between align-items-center'>
//             <h5 className='mb-0'>
//               <i className='fa fa-history me-2 text-theme'></i>
//               العقود السابقة
//             </h5>
//             {true && (
//               <button className='btn btn-theme btn-sm' onClick={() => setShowAddModal(true)}>
//                 <i className='fa fa-plus me-2'></i>
//                 إضافة عقد جديد
//               </button>
//             )}
//           </div>
          
//           <CardBody className='p-0'>
//             {previousContracts.length > 0 ? (
//               <div className='table-responsive'>
//                 <table className='table table-hover mb-0'>
//                   <thead className='table-light'>
//                     <tr>
//                       <th className='text-center'>رقم العقد</th>
//                       <th className='text-center'>نوع العقد</th>
//                       <th className='text-center'>تاريخ البداية</th>
//                       <th className='text-center'>تاريخ النهاية</th>
//                       <th className='text-center'>الإجازة السنوية</th>
//                       <th className='text-center'>الحالة</th>
//                       <th className='text-center'>الإجراءات</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {previousContracts.map((contract: any) => (
//                       <tr key={contract.id}>
//                         <td className='text-center align-middle'>
//                           <strong>{contract.contractNumber}</strong>
//                         </td>
//                         <td className='text-center align-middle'>{contract.contractType}</td>
//                         <td className='text-center align-middle'>
//                           {contract.startDate?.split('T')[0]}
//                         </td>
//                         <td className='text-center align-middle'>
//                           {contract.endDate?.split('T')[0]}
//                         </td>
//                         <td className='text-center align-middle'>
//                           <span className='badge bg-info'>{contract.annualLeave} يوم</span>
//                         </td>
//                         <td className='text-center align-middle'>
//                           <span className={`badge ${getStatusBadge(contract.contractStatus)}`}>
//                             {getStatusText(contract.contractStatus)}
//                           </span>
//                         </td>
//                         <td className='text-center align-middle'>
//                           <div className='btn-group btn-group-sm' role='group'>
//                             <button
//                               onClick={() => handleViewContract(contract)}
//                               className='btn btn-outline-theme'
//                               title='عرض التفاصيل'
//                             >
//                               <i className='fa fa-eye'></i>
//                             </button>
//                             {true && (
//                               <button
//                                 onClick={() => handleEditContract(contract)}
//                                 className='btn btn-outline-primary'
//                                 title='تعديل العقد'
//                               >
//                                 <i className='fa fa-edit'></i>
//                               </button>
//                             )}
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             ) : (
//               <div className='text-center py-5'>
//                 <i className='fa fa-inbox fa-3x text-muted mb-3'></i>
//                 <h5 className='text-muted'>لا توجد عقود سابقة</h5>
//                 <p className='text-muted'>لم يتم العثور على أي عقود سابقة لهذا الموظف</p>
//               </div>
//             )}
//           </CardBody>
//         </Card>

//         {/* زر إضافة عقد جديد - يظهر فقط إذا لم تكن هناك عقود سابقة */}
//         {previousContracts.length === 0 && true && (
//           <div className='text-center'>
//             <button className='btn btn-theme' onClick={() => setShowAddModal(true)}>
//               <i className='fa fa-plus me-2'></i>
//               إضافة عقد جديد
//             </button>
//           </div>
//         )}

//         {/* مودال الإضافة/التعديل */}
//         <NeatixModal
//           show={showAddModal}
//           setShow={setShowAddModal}
//           size='lg'
//           title={selectedContract ? 'تعديل العقد' : 'إضافة عقد جديد'}
//           centered
//         >
//           <ContractForm
//             personId={personId}
//             contract={selectedContract}
//             onSuccess={handleAddSuccess}
//             onCancel={() => {
//               setShowAddModal(false);
//               setSelectedContract(null);
//             }}
//             isEdit={!!selectedContract}
//           />
//         </NeatixModal>

//         {/* مودال العرض */}
//         <NeatixModal
//           show={showViewModal}
//           setShow={setShowViewModal}
//           size='lg'
//           centered
//           showHeader={false}
//           bodyClassName='p-0'
//         >
//           {selectedContract && <ViewContract contract={selectedContract} />}
//         </NeatixModal>
//       </div>
//     </Loading>
//   );
// };

// export default ContractsTab;


/* eslint-disable no-constant-binary-expression */
// ContractsTab.tsx
import React, { useEffect, useState } from 'react';
import { Card, CardBody } from '@components/card/card';
import NeatixModal from '@components/Modal/NeatixModal';
import Loading from '@components/Shared/Loader/Loading';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { useTranslation } from 'react-i18next';
import ContractForm from './ContractForm';
import ViewContract from './ViewContract';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import { getContractsList } from '@store/HR/Person/contractsSlice';

interface ContractsTabProps {
  personId: string;
}

const ContractsTab: React.FC<ContractsTabProps> = ({ personId }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { HasPermission } = usePermissions();

  const [showAddModal, setShowAddModal] = useState<boolean>(false);
  const [showViewModal, setShowViewModal] = useState<boolean>(false);
  const [selectedContract, setSelectedContract] = useState<any>(null);

  const { contractsList, loading, error } = useAppSelector(state => state.PersonContracts);

  useEffect(() => {
    if (personId) {
      dispatch(getContractsList(personId));
    }
  }, [dispatch, personId]);

  // دالة لتحديد العقد الحالي
  const getCurrentContract = () => {
    const today = new Date();
    return contractsList.find(contract => {
      const endDate = new Date(contract.endDate);
      return contract.contractStatus === 'active' && endDate >= today;
    });
  };

  // دالة للحصول على العقود السابقة
  const getPreviousContracts = () => {
    const today = new Date();
    return contractsList.filter(contract => {
      const endDate = new Date(contract.endDate);
      return contract.contractStatus !== 'active' || endDate < today;
    });
  };

  const currentContract = getCurrentContract();
  const previousContracts = getPreviousContracts();

  const handleAddSuccess = () => {
    setShowAddModal(false);
    setSelectedContract(null);
    dispatch(getContractsList(personId));
  };

  const handleViewContract = (contract: any) => {
    setSelectedContract(contract);
    setShowViewModal(true);
  };

  const handleEditContract = (contract: any) => {
    setSelectedContract(contract);
    setShowAddModal(true);
  };

  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'active':
        return 'bg-success';
      case 'expired':
        return 'bg-warning';
      case 'terminated':
        return 'bg-danger';
      case 'suspended':
        return 'bg-secondary';
      default:
        return 'bg-secondary';
    }
  };

  const getStatusText = (status: string) => {
    switch (status) {
      case 'active':
        return 'نشط';
      case 'expired':
        return 'منتهي';
      case 'terminated':
        return 'ملغي';
      case 'suspended':
        return 'موقوف';
      default:
        return status;
    }
  };

  const calculateRemainingDays = (endDate: string) => {
    const today = new Date();
    const end = new Date(endDate);
    const diffTime = end.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays > 0 ? diffDays : 0;
  };

  const calculateContractDuration = (startDate: string, endDate: string) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const diffTime = end.getTime() - start.getTime();
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  return (
    <Loading loading={loading} error={error}>
      <div>
        {/* بطاقات الإحصائيات الصغيرة */}
        <div className='row mb-4'>
          <div className='col-md-3 col-6'>
            <Card className=' shadow h-100'>
              <CardBody className='p-3'>
                <div className='d-flex align-items-center'>
                  <div className='flex-shrink-0'>
                    <div className='bg-primary bg-opacity-10 rounded p-2'>
                      <i className='fa fa-file-contract text-primary fs-5'></i>
                    </div>
                  </div>
                  <div className='flex-grow-1 ms-3'>
                    <h4 className='mb-0'>{contractsList.length}</h4>
                    <small className='text-muted'>إجمالي العقود</small>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
          <div className='col-md-3 col-6'>
            <Card className=' shadow h-100'>
              <CardBody className='p-3'>
                <div className='d-flex align-items-center'>
                  <div className='flex-shrink-0'>
                    <div className='bg-success bg-opacity-10 rounded p-2'>
                      <i className='fa fa-star text-success fs-5'></i>
                    </div>
                  </div>
                  <div className='flex-grow-1 ms-3'>
                    <h4 className='mb-0'>{currentContract ? 1 : 0}</h4>
                    <small className='text-muted'>العقد الحالي</small>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
          <div className='col-md-3 col-6'>
            <Card className=' shadow h-100'>
              <CardBody className='p-3'>
                <div className='d-flex align-items-center'>
                  <div className='flex-shrink-0'>
                    <div className='bg-warning bg-opacity-10 rounded p-2'>
                      <i className='fa fa-history text-warning fs-5'></i>
                    </div>
                  </div>
                  <div className='flex-grow-1 ms-3'>
                    <h4 className='mb-0'>{previousContracts.length}</h4>
                    <small className='text-muted'>العقود السابقة</small>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
          <div className='col-md-3 col-6'>
            <Card className=' shadow h-100'>
              <CardBody className='p-3'>
                <div className='d-flex align-items-center'>
                  <div className='flex-shrink-0'>
                    <div className='bg-info bg-opacity-10 rounded p-2'>
                      <i className='fa fa-calendar-day text-info fs-5'></i>
                    </div>
                  </div>
                  <div className='flex-grow-1 ms-3'>
                    <h4 className='mb-0'>
                      {currentContract ? calculateRemainingDays(currentContract.endDate) : 0}
                    </h4>
                    <small className='text-muted'>الأيام المتبقية</small>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>

        {/* قسم العقد الحالي */}
        {currentContract ? (
          <Card className='mb-4 border-success'>
            <div className='card-header bg-success bg-opacity-10 border-success d-flex justify-content-between align-items-center'>
              <h5 className='mb-0 text-success'>
                <i className='fa fa-star me-2'></i>
                العقد الحالي
              </h5>
              <div>
                <span className='badge bg-success me-2'>
                  <i className='fa fa-clock me-1'></i>
                  {calculateRemainingDays(currentContract.endDate)} يوم متبقي
                </span>
                <span className='badge bg-primary'>
                  {calculateContractDuration(currentContract.startDate, currentContract.endDate)} يوم
                </span>
              </div>
            </div>
            <CardBody>
              <div className='row'>
                <div className='col-md-3'>
                  <div className='text-center mb-3'>
                    <h4 className='text-theme'>{currentContract.contractNumber}</h4>
                    <small className='text-muted'>رقم العقد</small>
                  </div>
                </div>
                <div className='col-md-3'>
                  <div className='text-center mb-3'>
                    <h6 className='text-dark'>{currentContract.contractType}</h6>
                    <small className='text-muted'>نوع العقد</small>
                  </div>
                </div>
                <div className='col-md-3'>
                  <div className='text-center mb-3'>
                    <h6 className='text-dark'>{currentContract.startDate?.split('T')[0]}</h6>
                    <small className='text-muted'>تاريخ البداية</small>
                  </div>
                </div>
                <div className='col-md-3'>
                  <div className='text-center mb-3'>
                    <h6 className='text-dark'>{currentContract.endDate?.split('T')[0]}</h6>
                    <small className='text-muted'>تاريخ النهاية</small>
                  </div>
                </div>
              </div>

              <div className='row mt-3'>
                <div className='col-md-6'>
                  <div className='d-flex flex-wrap gap-2'>
                    <span className='badge bg-info'>{currentContract.annualLeave} يوم إجازة سنوية</span>
                    <span className={`badge ${currentContract.approvedFlag ? 'bg-success' : 'bg-warning'}`}>
                      {currentContract.approvedFlag ? 'معتمد' : 'غير معتمد'}
                    </span>
                    <span className='badge bg-secondary'>{currentContract.signedBy}</span>
                  </div>
                </div>
                <div className='col-md-6 text-end'>
                  <div className='btn-group'>
                    <button
                      onClick={() => handleViewContract(currentContract)}
                      className='btn btn-outline-theme btn-sm'
                    >
                      <i className='fa fa-eye me-1'></i>
                      عرض التفاصيل
                    </button>
                    {true && (
                      <button onClick={() => handleEditContract(currentContract)} className='btn btn-theme btn-sm'>
                        <i className='fa fa-edit me-1'></i>
                        تعديل
                      </button>
                    )}
                  </div>
                </div>
              </div>

              {currentContract.description && (
                <div className='row mt-3'>
                  <div className='col-12'>
                    <div className='border-top pt-3'>
                      <h6 className='text-muted'>ملاحظات:</h6>
                      <p className='mb-0'>{currentContract.description}</p>
                    </div>
                  </div>
                </div>
              )}
            </CardBody>
          </Card>
        ) : (
          <Card className='mb-4 border-warning'>
            <CardBody className='text-center py-4'>
              <i className='fa fa-exclamation-triangle fa-2x text-warning mb-3'></i>
              <h5 className='text-warning'>لا يوجد عقد نشط حالياً</h5>
              <p className='text-muted mb-3'>هذا الموظف لا يمتلك عقداً نشطاً في الوقت الحالي</p>
              {true && (
                <button className='btn btn-theme' onClick={() => setShowAddModal(true)}>
                  <i className='fa fa-plus me-2'></i>
                  إضافة عقد جديد
                </button>
              )}
            </CardBody>
          </Card>
        )}











        

        {/* قسم العقود السابقة - كجدول */}
        <Card className='mb-4'>
          <div className='card-header d-flex justify-content-between align-items-center'>
            <h5 className='mb-0'>
              <i className='fa fa-history me-2 text-theme'></i>
              العقود السابقة
            </h5>
            {true && (
              <button className='btn btn-theme btn-sm' onClick={() => setShowAddModal(true)}>
                <i className='fa fa-plus me-2'></i>
                إضافة عقد جديد
              </button>
            )}
          </div>
          
          <CardBody className='p-0'>
            {previousContracts.length > 0 ? (
              <div className='table-responsive'>
                <table className='table table-hover mb-0'>
                  <thead className='table-light'>
                    <tr>
                      <th className='text-center'>رقم العقد</th>
                      <th className='text-center'>نوع العقد</th>
                      <th className='text-center'>تاريخ البداية</th>
                      <th className='text-center'>تاريخ النهاية</th>
                      <th className='text-center'>الإجازة السنوية</th>
                      <th className='text-center'>الحالة</th>
                      <th className='text-center'>الإجراءات</th>
                    </tr>
                  </thead>
                  <tbody>
                    {previousContracts.map((contract: any) => (
                      <tr key={contract.id}>
                        <td className='text-center align-middle'>
                          <strong>{contract.contractNumber}</strong>
                        </td>
                        <td className='text-center align-middle'>{contract.contractType}</td>
                        <td className='text-center align-middle'>
                          {contract.startDate?.split('T')[0]}
                        </td>
                        <td className='text-center align-middle'>
                          {contract.endDate?.split('T')[0]}
                        </td>
                        <td className='text-center align-middle'>
                          <span className='badge bg-info'>{contract.annualLeave} يوم</span>
                        </td>
                        <td className='text-center align-middle'>
                          <span className={`badge ${getStatusBadge(contract.contractStatus)}`}>
                            {getStatusText(contract.contractStatus)}
                          </span>
                        </td>
                        <td className='text-center align-middle'>
                          <div className='btn-group btn-group-sm' role='group'>
                            <button
                              onClick={() => handleViewContract(contract)}
                              className='btn btn-outline-theme'
                              title='عرض التفاصيل'
                            >
                              <i className='fa fa-eye'></i>
                            </button>
                            {true && (
                              <button
                                onClick={() => handleEditContract(contract)}
                                className='btn btn-outline-primary'
                                title='تعديل العقد'
                              >
                                <i className='fa fa-edit'></i>
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className='text-center py-5'>
                <i className='fa fa-inbox fa-3x text-muted mb-3'></i>
                <h5 className='text-muted'>لا توجد عقود سابقة</h5>
                <p className='text-muted'>لم يتم العثور على أي عقود سابقة لهذا الموظف</p>
              </div>
            )}
          </CardBody>
        </Card>

        {/* زر إضافة عقد جديد - يظهر فقط إذا لم تكن هناك عقود سابقة */}
        {previousContracts.length === 0 && true && (
          <div className='text-center'>
            <button className='btn btn-theme' onClick={() => setShowAddModal(true)}>
              <i className='fa fa-plus me-2'></i>
              إضافة عقد جديد
            </button>
          </div>
        )}

        {/* مودال الإضافة/التعديل */}
        <NeatixModal
          show={showAddModal}
          setShow={setShowAddModal}
          size='lg'
          title={selectedContract ? 'تعديل العقد' : 'إضافة عقد جديد'}
          centered
        >
          <ContractForm
            personId={personId}
            contract={selectedContract}
            onSuccess={handleAddSuccess}
            onCancel={() => {
              setShowAddModal(false);
              setSelectedContract(null);
            }}
            isEdit={!!selectedContract}
          />
        </NeatixModal>

        {/* مودال العرض */}
        <NeatixModal
          show={showViewModal}
          setShow={setShowViewModal}
          size='lg'
          centered
          showHeader={false}
          bodyClassName='p-0'
        >
          {selectedContract && <ViewContract contract={selectedContract} />}
        </NeatixModal>
      </div>
    </Loading>
  );
};

export default ContractsTab;